import * as React from "react";
import {Fragment} from "react";
import "react-big-calendar/lib/css/react-big-calendar.css"
import Event from "../../../model/event/Event";
import {AppointmentStatusEnum} from "../../../model/appointment/AppointmentStatus";
import EventWrapper from "./EventWrapper";
import {View} from "react-big-calendar";
import {FullCalendarFilters} from "../../../store/local/model/FullCalendarFilters";
import LocalStorage from "../../../store/local/LocalStorage";
import Tooltip from "../../../hiberUiKit/src/atoms/Tooltip/Tooltip";
import {withRouter} from "react-router";
import AppointmentCalendarTooltipBody from "./AppointmentCalendarTooltipBody";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import AppointmentDetails from "../../../model/appointment/AppointmentDetails";
import {Dispatch} from "redux";
import {OnSuccessData} from "../../../store/action/actionHelpers";
import {fetchJobsAppointmentsInDateRange, fetchLeadsAppointmentsInDateRange} from "../../../store/action/appointment/appointment";
import {connect} from "react-redux";
import moment = require("moment");

const BigCalendar = require("react-big-calendar");
BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

interface IState {
	/**
	 * Selected calendar view mode.
	 */
	view: string;
	/**
	 * Selected calendar date.
	 */
	date: moment.Moment;
	/**
	 * Full calendar stored filters object.
	 */
	storedData: FullCalendarFilters;
	/**
	 * Selected event
	 */
	event: Event;
	/**
	 * Events
	 */
	events: Event[]
}

interface DispatchProps {
	fetchLeadsAppointmentsInDateRange: (dateFrom: moment.Moment,
		dateTo: moment.Moment,
		onSuccess: OnSuccessData<AppointmentDetails[]>) => void
	fetchJobsAppointmentsInDateRange: (dateFrom: moment.Moment,
		dateTo: moment.Moment,
		onSuccess: OnSuccessData<AppointmentDetails[]>) => void
}


class AppointmentCalendar extends React.Component<DispatchProps, IState> {
	constructor(props: DispatchProps) {
		super(props);
		const filters = LocalStorage.getFullCalendarFilters();
		this.state = {
			view: filters.view,
			date: moment(filters.date),
			storedData: filters,
			event: null,
			events: []
		};
		this.onDateChange = this.onDateChange.bind(this);
		this.onViewChange = this.onViewChange.bind(this);
		this.eventStyleGetter = this.eventStyleGetter.bind(this);
	}

	componentDidMount() {
		this.fetchAppointments()
	}

	render() {
		return (
			<Fragment>
				<BigCalendar
					views={['month', 'week', 'agenda']}
					events={this.state.events}
					step={15}
					timeslots={8}
					onView={(view: View) => this.onViewChange(view)}
					onNavigate={(newDate: Date) => this.onDateChange(moment(newDate))}
					defaultView={this.state.view}
					defaultDate={this.state.date.toDate()}
					showMultiDayTimes
					min={moment().startOf("day").add(6, "hours").toDate()}
					max={moment().endOf("day").toDate()}
					components={{
						event: EventComponent,
						eventWrapper: EventWrapper
					}}
					onSelectEvent={(e: Event) => this.setState({event: e})}
					eventPropGetter={(this.eventStyleGetter)}
					popup={true}
					popupOffset={100}/>
				{this.state.event &&
				<Tooltip parentRef={document.getElementById(this.state.event.id).querySelector(".rbc-event")}
						 onOutsideClick={() => {this.setState({event: null})}}>
					<AppointmentCalendarTooltipBody event={this.state.event}/>
				</Tooltip>
				}
			</Fragment>
		)
	}

	eventStyleGetter(event: any) {
		const className = event.status.value == AppointmentStatusEnum.Confirmed ?
			"c-event-item confirmed" :
			"c-event-item unconfirmed";
		return {
			className: this.state.view !== "agenda" ? className : ""
		}
	}

	/**
	 * Calendar view mode change callback.
	 * @param {string} view
	 */
	onViewChange(view: View) {
		this.setState({view: view, storedData: this.state.storedData.updateView(view)}, this.fetchAppointments);
	}

	/**
	 * Calendar date change callback.
	 * @param {moment.Moment} date
	 */
	onDateChange(date: moment.Moment) {
		this.setState({date: date, storedData: this.state.storedData.updateDate(date)}, this.fetchAppointments)
	}

	fetchAppointments = () => {
		let dateFrom: moment.Moment, dateTo: moment.Moment;
		if (this.state.view == "agenda") {
			dateFrom = this.state.date;
			dateTo = this.state.date.clone().add(1, "month")
		}
		else if (this.state.view == "week") {
			dateFrom = this.state.date.clone().startOf("week");
			dateTo = this.state.date.clone().endOf("week")
		}
		else if (this.state.view == "month") {
			dateFrom = this.state.date.clone().startOf("month").add(-1, "week")
			dateTo = this.state.date.clone().endOf("month").add(1, "week")
		}

		this.setState({events: []}, () => {
			const onSuccess = (app: AppointmentDetails[]) => this.setState(
				{events: this.state.events.concat(app.map(ad => ad.toEvent()))})
			this.props.fetchLeadsAppointmentsInDateRange(dateFrom, dateTo, onSuccess);
			this.props.fetchJobsAppointmentsInDateRange(dateFrom, dateTo, onSuccess);
		})
	}
}

function EventComponent(e: { event: Event, title: string }) {
	return (
		<span>
			<strong>{e.event.getReferenceTitle()}</strong>
			{e.event.desc && ": " + e.event.desc}
		</span>
	)
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchLeadsAppointmentsInDateRange: (dateFrom: moment.Moment,
			dateTo: moment.Moment,
			onSuccess: OnSuccessData<AppointmentDetails[]>) => dispatch(
			fetchLeadsAppointmentsInDateRange(dateFrom, dateTo, onSuccess,
				e => notifyBugsnagAndShowToast(e, "Fetch Leads appointments"))),
		fetchJobsAppointmentsInDateRange: (dateFrom: moment.Moment,
			dateTo: moment.Moment,
			onSuccess: OnSuccessData<AppointmentDetails[]>) => dispatch(
			fetchJobsAppointmentsInDateRange(dateFrom, dateTo, onSuccess,
				e => notifyBugsnagAndShowToast(e, "Fetch Jobs appointments")))
	}
}

export default withRouter(connect(null, mapDispatchToProps)(AppointmentCalendar));

